const onPageHide = (callback) => {
    let isUnloaded = false;
    window.addEventListener("pagehide", () => {
        if (isUnloaded)
            return;
        isUnloaded = true;
        callback();
    });
    window.addEventListener("beforeunload", () => {
        if (isUnloaded)
            return;
        isUnloaded = true;
        callback();
    });
    document.addEventListener("visibilitychange", () => {
        if (document.visibilityState == "hidden") {
            if (isUnloaded)
                return;
            isUnloaded = true;
            callback();
        }
        else {
            isUnloaded = false;
        }
    });
};

export { onPageHide };
//# sourceMappingURL=onPageHide.js.map
